<script>

import TheStudentScholarshipScoreCard from "../Cards/Student/TheStudentScholarshipScoreCard.vue";
import TheStudentScholarshipHeaderCard from "../Cards/Student/TheStudentScholarshipHeaderCard.vue";
import TheStudentScholarshipRatingCard from "../Cards/Student/TheStudentScholarshipRatingCard.vue";
import TheStudentScholarshipCommentsCard from "../Cards/Student/TheStudentScholarshipCommentsCard.vue";
import ScholarshipCompetitionApi from "../Services/Api/ScholarshipCompetitionApi";
import PeriodScholarship from "../Services/PeriodScholarship";

const TheStudentShowStatementDialog = () => import("../Dialogs/Student/TheStudentShowStatementDialog.vue");
import _ from "lodash";
import AmsuScholarshipCard from "../Cards/AmsuScholarshipCard.vue";

export default {
  name: "TheStudentScholarshipContainer",

  components: {
    AmsuScholarshipCard,
    TheStudentScholarshipScoreCard,
    TheStudentScholarshipHeaderCard,
    TheStudentScholarshipRatingCard,
    TheStudentScholarshipCommentsCard,
    TheStudentShowStatementDialog,
  },

  data() {
    return {
      statements: [],
      personScores: {},
      dialogStatement: false,
      statementStudent: {},
      commentsStudent: [],
      facultyName: "",
      completedStatements: [],
    };
  },

  mounted() {
    this.getStatements();
  },

  computed: {
    isPersonScoresPresent() {
      return !_.isNil(this.personScores);
    },

    isPeriodScholarship() {
      return PeriodScholarship.fullPeriod();
    },
  },

  methods: {
    async getStatements() {
      const response = await ScholarshipCompetitionApi.index();
      if(_.isNil(response)) return;

      if (!response.data.hasOwnProperty("error")) {
        this.statements = response.data.competitions;
        this.personScores = response.data?.person_competition?.person_scores[0];
        this.commentsStudent = response.data?.comments;
        this.facultyName = response.data?.faculty;
        this.completedStatements = _.filter(this.statements, statement => response.data.completed_statements.includes(statement.id));
      }
    },

    async getStatementStudent(id) {
      const response = await ScholarshipCompetitionApi.show(id);
      if(_.isNil(response)) return;

      if (!response.data.hasOwnProperty("error")) {
        this.statementStudent = response.data.competition;
      }
    },

    openDialogStatementStudent(id) {
      this.getStatementStudent(id);
      this.dialogStatement = true;
    },

    closeDialogStatementStudent() {
      this.statementStudent = {};
      this.dialogStatement = false;
    },
  },

}
</script>

<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <the-student-scholarship-header-card
          :name-faculty="facultyName"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-row>
          <v-col cols="12">
            <the-student-scholarship-score-card
              :person-scores="personScores"
              :is-person-scores-present="isPersonScoresPresent"
            />
          </v-col>

          <v-col cols="12">
            <amsu-scholarship-card v-if="!isPeriodScholarship">
              <v-card-text class="text-body-1 font-weight-bold text-center">
                Конкурс студентов на ПГАС закрыт, отображается прошлый конкурс
              </v-card-text>
            </amsu-scholarship-card>
          </v-col>

          <v-col cols="12">
            <the-student-scholarship-comments-card
              :comments="commentsStudent"
              v-show="isPersonScoresPresent"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="8">
        <the-student-scholarship-rating-card
          @openStatement="openDialogStatementStudent"
          :statements="statements"
          :completed-statements="completedStatements"
        />
      </v-col>
    </v-row>

    <the-student-show-statement-dialog
      :visible="dialogStatement"
      :statement-student="statementStudent"
      @close="closeDialogStatementStudent"
    />
  </v-container>
</template>

<style scoped>

</style>